import React from 'react';
import { Box, TextField, TextFieldProps } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

interface CalendarFieldProps {
  label?: string;
  labelStyle?: React.CSSProperties;
  value: Dayjs | null;
  onChange: (newValue: Dayjs | null) => void;
  textFieldProps?: TextFieldProps;
  disablePast?: boolean;
  disabledBefore?: string;
  preventManual?: boolean;
  minDate?: string | Dayjs;
  maxDate?: string | Dayjs;
  containerStyle?: React.CSSProperties;
  allowEmpty?: boolean
}

const CalendarField: React.FC<CalendarFieldProps> = ({
  label,
  labelStyle,
  value,
  onChange,
  textFieldProps,
  disablePast = false,
  disabledBefore,
  preventManual = false,
  minDate,
  maxDate,
  containerStyle = {},
  allowEmpty = false
}) => {
  const shouldDisableDate = (date: Dayjs | null) => {
    // // disable all days before custom day
    if (disablePast && disabledBefore && date) {
      return date.isBefore(dayjs(disabledBefore), 'day');
    }
    // // disable all days before today
    else if (disablePast) {
      return date && date.isBefore(dayjs(), 'day')
    }
    else if (minDate && date.isBefore(dayjs(minDate), 'day')) return true;
    else if (maxDate && date.isAfter(dayjs(maxDate), 'day')) return true;
    return false;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ ...containerStyle }}>
        {label && <label style={labelStyle}>{label}</label>}
        <DatePicker
          value={value}
          onChange={onChange}
          shouldDisableDate={shouldDisableDate}
          views={['year', 'month', 'day']}
          renderInput={(params) => (
            <TextField
              fullWidth
              {...params}
              {...textFieldProps}
              inputProps={{
                ...params.inputProps,
                readOnly: preventManual,
              }}
              {...(allowEmpty ? { error: false } : {})}
            />
          )}
          PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [38, 0],
                },
              }
            ],
          }}
          {...(minDate ? { minDate } : {})}
          {...(maxDate ? { maxDate } : {})}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default CalendarField;
